module.exports = __webpack_public_path__ + "img/3_6.f263f4b8.png";